import React from 'react';

const RELOAD_KEY = '__shipping_chunk_reload';
const RELOAD_GUARD_MS = 15000;

export function isChunkLoadError(error) {
  if (!error) return false;
  if (error.name === 'ChunkLoadError') return true;
  const msg = String(error.message || error);
  return /Loading chunk .+ failed/i.test(msg)
    || /Failed to fetch dynamically imported module/i.test(msg)
    || /error loading dynamically imported module/i.test(msg);
}

export function recoverChunkLoadError(error) {
  if (!isChunkLoadError(error) || typeof window === 'undefined') return false;
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY) || 0);
    const now = Date.now();
    if (last && now - last < RELOAD_GUARD_MS) return false;
    window.sessionStorage.setItem(RELOAD_KEY, String(now));
  } catch {
    // sessionStorage can throw in private mode; still reload once
  }
  window.location.reload();
  return true;
}

export function retryLazyImport(importer, { retries = 3, delayMs = 400 } = {}) {
  const attempt = (remaining) => importer().catch((error) => {
    if (!isChunkLoadError(error)) throw error;
    if (remaining <= 0) {
      if (recoverChunkLoadError(error)) return new Promise(() => {});
      throw error;
    }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        attempt(remaining - 1).then(resolve, reject);
      }, delayMs);
    });
  });
  return attempt(retries);
}

export function lazyWithRetry(importer) {
  return React.lazy(() => retryLazyImport(importer));
}
